export default "__VITE_ASSET__fd326039__"